import { cloneDeep } from 'lodash';
import * as React from 'react';

import { ICrop, IDocument, IUserData } from '../../../../infrastructure/interfaces';
import CropsEditorForm from '../../../DocumentEditor/CropsEditorForm';
import SettingsNav from './SettingsNav';


export interface ICropsEditorProps {
  document: IDocument;
  crops: ICrop[];
  userData: IUserData;
  updateDocument(document: IDocument, userID: string): void;
  updateModelDocument?(document: IDocument): void;
  cancelDocument?(): void;
}

export interface ICropsEditorState {
  document: IDocument;
  crops: ICrop[];
}

export default class CropsEditor extends React.Component<ICropsEditorProps, ICropsEditorState> {
  contentNode: Element;
  constructor(props: ICropsEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
      crops: props.crops,
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.contentNode.parentElement!.scrollTop = 0;
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: ICropsEditorProps) {
    if (this.props.document !== nextProps.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  toggleCrop = (crop: ICrop) => {
    let crops = [...this.state.document.crops];

    if (crops.find(c => c.id === crop.id)) {
      crops = crops.filter(c => c.id !== crop.id);
    } else {
      crops.push(crop);
    }

    this.setState({
      document: {
        ...this.state.document,
        crops,
      },
    });
  }

  changeCropImage = (crop: ICrop, defaultImage: string) => {

    const allCrops = this.state.crops
      .map(c => c.id === crop.id
        ? { ...c, defaultImage }
        : c);

    const crops = this.state.document.crops
      .map(c => c.id === crop.id
        ? { ...c, defaultImage }
        : c);

    this.setState({
      document: {
        ...this.state.document,
        crops,
      },
      crops: allCrops,
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  save = () => {
    this.props.updateDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer" ref={(node) => { this.contentNode = node!; }}>
        <SettingsNav
          onSave={this.save}
          cancel={this.cancel}
          document={this.state.document}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Crops for Cover Photos
          </div>
        </div>
        <CropsEditorForm
          className="settingsCropsListContainer settingsCropsListContainer--crops"
          document={this.state.document}
          crops={this.state.crops}
          toggleCrop={this.toggleCrop}
          changeCropImage={this.changeCropImage}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/CropsEditor.tsx